import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-sos-screen',
  templateUrl: './sos-screen.component.html',
  styleUrls: ['./disclaimer.component.css']
})
export class SosScreenComponent implements OnInit {

  constructor(private _location: Location) { }

  ngOnInit(): void {
  }

  back(){
    this._location.back();
  }
}
